import React from 'react';
import { CalendarPanelSC } from './calendar-panel.styled';
import classNames from 'classnames';
import { TDatePanelOption } from './calendar-panel.types';
import ListItem from '@components/ui/list-item';

interface CalendarPanelProps
  extends Omit<
    React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref'
  > {
  children?: React.ReactNode;
  footer?: React.ReactNode;
  options?: TDatePanelOption[];
  onOptionClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>, dates: Date[]) => void;
}

const CalendarPanel = (
  { children, footer, className, options, onOptionClick, ...rest }: CalendarPanelProps,
  ref?: React.Ref<HTMLDivElement>,
) => {
  return (
    <CalendarPanelSC
      className={classNames(className, { 'has-footer': !!footer })}
      ref={ref}
      {...rest}
    >
      <div className="content-wrapper">
        {options && options.length > 0 ? (
          <div className="options-wrapper">
            {options?.map((opt, i) => (
              <ListItem
                key={i}
                onClick={(e) => {
                  e.stopPropagation();
                  onOptionClick?.(e, opt.value);
                }}
              >
                {opt.label}
              </ListItem>
            ))}
          </div>
        ) : null}
        <div className="calendars-wrapper">{children}</div>
      </div>
      <div className="footer-wrapper">{footer}</div>
    </CalendarPanelSC>
  );
};

export default React.forwardRef(CalendarPanel);
